/** Shared cancellation / endorsement instruction copy for law-firm and team-member bond pages. */

export function getCancellationInstructions(bond) {
  const amount = Number.parseFloat(bond.bond_amount || 0);
  const type = bond.bond_type;

  if (type === "Probate") {
    if (amount <= 250000) {
      return "Probate\n\nBonds up to $250,000\n\n• Discharge from the court\n\n• Statement from attorney on their letterhead stating all debts are paid and balances distributed to the remaining heirs";
    }
    return "Probate\n\nBonds over $250,000 require one of the following to close:\n\n• Final Accounting\n\n• Discharge from the court\n\n• Copy of verification of closing evidence from a court's online system";
  }

  if (type === "Guardianship") {
    const instructions =
      amount <= 1000000
        ? "Guardianship\n\nBonds up to $1,000,000 also accept one of the following to close:\n\n• Final Accounting\n\n• Discharge from the court\n\n• Statement from attorney on their letterhead stating all debts are paid and balances distributed to the remaining heirs and/or beneficiaries"
        : "Guardianship\n\nBonds over $1,000,000 require one of the following to close:\n\n• Final Accounting\n\n• Discharge from the court\n\n• Copy of verification of closing evidence from a court's online system";
    const successorNote =
      "\n\nIf a Successor Bond has been filed with the court:\n\n• Guardianship - Evidence of death of the incompetent\n\n• Minor Guardian - Evidence of the minor reaching the age of majority";
    return instructions + successorNote;
  }

  if (type === "VA") {
    return "VA Bonds\n\nExoneration Letter from the VA";
  }

  if (type === "Trustee") {
    return "Trustee Bond\n\n• Court's Release\n\n• Final Accounting\n\n• Evidence that either the beneficiary of trust has died or that trust assets have been fully dispersed to beneficiary(s) per the Trust";
  }

  if (type === "Blanket") {
    return "📩 Upload email confirmation that renewal is not required.";
  }

  return "⚠️ Upload appropriate closing document for this bond.";
}

export function getCancellationInstructionsList(bond) {
  const amount = Number.parseFloat(bond.bond_amount || 0);
  const type = bond.bond_type;
  if (type === "Probate") {
    if (amount <= 250000) {
      return [
        "Discharge from the court",
        "Statement from attorney on their letterhead stating all debts are paid and balances distributed to the remaining heirs",
      ];
    }
    return [
      "Final Accounting",
      "Discharge from the court",
      "Copy of verification of closing evidence from a court's online system",
    ];
  }
  if (type === "Guardianship") {
    const main =
      amount <= 1000000
        ? [
            "Final Accounting",
            "Discharge from the court",
            "Statement from attorney on their letterhead stating all debts are paid and balances distributed to the remaining heirs and/or beneficiaries",
          ]
        : [
            "Final Accounting",
            "Discharge from the court",
            "Copy of verification of closing evidence from a court's online system",
          ];
    return [
      ...main,
      "If a Successor Bond has been filed with the court:",
      "Guardianship - Evidence of death of the incompetent",
      "Minor Guardian - Evidence of the minor reaching the age of majority",
    ];
  }
  if (type === "VA") return ["Exoneration Letter from the VA"];
  if (type === "Trustee") {
    return [
      "Court's Release",
      "Final Accounting",
      "Evidence that either the beneficiary of trust has died or that trust assets have been fully dispersed to beneficiary(s) per the Trust",
    ];
  }
  if (type === "Blanket") return ["Email confirmation that renewal is not required."];
  return ["Upload appropriate closing document for this bond."];
}

export function getEndorsementInstructions(bond) {
  const type = bond.bond_type;

  const typeSupports = {
    courtOrder: ["Probate", "Guardianship", "Trustee"],
    accounting: ["Guardianship", "Trustee"],
    vaLetter: ["VA"],
  };

  return [
    ...(typeSupports.courtOrder.includes(type)
      ? ["• Court Order or Endorsement Checklist"]
      : []),
    ...(typeSupports.accounting.includes(type)
      ? ["• Annual Accounting Documentation"]
      : []),
    ...(typeSupports.vaLetter.includes(type) ? ["• VA Letter of Endorsement"] : []),
  ];
}
